import { useField } from 'formik';

import { InputWrapper } from '../../components/InputWrapper';
import type { TrailerOption } from './displayTrailer';
import { TrailerCombobox } from './TrailerCombobox';

export interface ITrailerComboboxFieldProps {
  name: string;
  labelText?: string;
  helperText?: string;
  isDisabled?: boolean;
}

export const TrailerComboboxField: React.FC<ITrailerComboboxFieldProps> = (props) => {
  const { name, labelText = 'Trailer', helperText, isDisabled } = props;

  const [field, meta, helpers] = useField<TrailerOption | null>({ name });

  return (
    <InputWrapper labelText={labelText} invalidText={meta.touched ? meta.error : undefined} helperText={helperText}>
      <TrailerCombobox
        value={field.value ?? null}
        onChange={(val) => helpers.setValue(val)}
        onBlur={() => helpers.setTouched(true)}
        isDisabled={isDisabled}
        isInvalid={Boolean(meta.touched && meta.error)}
      />
    </InputWrapper>
  );
};
